import React from 'react';
import {
  TextField,
  useMediaQuery,
  useTheme,
} from '@material-ui/core';
import {
  Box,
  inputLabelProps,
  inputMUIDefaultStyles,
} from '../../common/styles';
import { IUseFormData } from '../../common/contracts';
import { emailValidation } from '../../common/validations/forms';

export function EmailBoxInputs({
  formData,
  defaultValue,
}: {
  formData: IUseFormData,
  defaultValue: any,
}) {
  const {
    register,
    errors,
  } = formData;

  const theme = useTheme();
  const isSmallScreen = useMediaQuery(
    theme.breakpoints.down('xs'),
  );

  return (
    <Box>
      <TextField
        variant="outlined"
        required
        type="email"
        label="Email"
        autoComplete="email"
        style={
          isSmallScreen
            ? inputMUIDefaultStyles.normal
            : inputMUIDefaultStyles.large
        }
        error={!!errors.email}
        helperText={errors.email ? errors.email.message : ''}
        {...register('email', emailValidation)}
        defaultValue={defaultValue?.email}
        inputProps={{
          maxLength: 254,
        }}
        InputLabelProps={{
          ...inputLabelProps,
        }}
      />
    </Box>
  );
}
